import { useModelService } from 'services/model/model.service';
import { customKpi, measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useCategoryDashboardKpis(): InfoDrawerKpiEntry[] {
  const { getMeasureByMetric, getMeasures } = useModelService();

  const gmvMeasure = getMeasureByMetric('ordGmvVal', 'OD');
  const [retRateMeasure] = getMeasures(['retQtyRateExpOD']);

  return [
    measureKpi(gmvMeasure),
    measureKpi(retRateMeasure),
    customKpi('orderedGMVGrowth', {
      titleId: 'insights.measure.orderedGMVGrowth.name',
      descriptionId: 'insights.measure.oorderedGMVGrowth.description',
    }),
    customKpi('orderedGMVGrowthValue', {
      titleId: 'insights.measure.orderedGMVGrowthValue.name',
      descriptionId: 'insights.measure.oorderedGMVGrowthValue.description',
    }),
    customKpi('avgSoldItemsPerProduct', {
      titleId: 'model.calculated.metric.avgSoldItemsPerProduct.name',
      descriptionId: 'model.calculated.metric.avgSoldItemsPerProduct.description',
    }),
    customKpi('slsPrdNum', {
      titleId: 'model.metric.slsPrdNum.name',
      descriptionId: 'model.metric.slsPrdNum.description',
    }),
    customKpi('slsQty', {
      titleId: 'model.metric.slsQty.name',
      descriptionId: 'model.metric.slsQty.description',
    }),
  ];
}

export function CategoryDashboardInfoContent() {
  const kpis = useCategoryDashboardKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulDescriptionId="insights.category_tab.info.content.why_is_this_view_useful_description"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
